import { forEach, set } from 'lodash'

export type TConstantMap = {
  REQUEST: string
  RECEIVE: string
  SET_FILTER: string
  APPLY_FILTER: string
  SAVE_UI: string
  SET_FILTER_MODE: string
  SET_INCLUDED: string
  CLEAR_FILTERS: string
  SET_SORT: string
  APPLY_LOCAL_FILTER: string
  SET_ITEMS: string
  APPLY_LOCAL_FULLTEXTFILTER: string
  APPLY_LOCAL_SORT: string
  SORT_LOCAL: string
  APPLY_LOCAL_VALUEFILTER: string
  SET_LOADING: string
  SET_GROUPING: string
  SET_REQUEST_ID: string
  SET_CUSTOM_HEADERS: string
  SET_CUSTOM_PAYLOAD: string
}

const constants: string[] = [
  'REQUEST',
  'RECEIVE',
  'SET_FILTER',
  'APPLY_FILTER',
  'SAVE_UI',
  'SET_FILTER_MODE',
  'SET_INCLUDED',
  'CLEAR_FILTERS',
  'SET_SORT',
  'APPLY_LOCAL_FILTER',
  'SET_ITEMS',
  'APPLY_LOCAL_FULLTEXTFILTER',
  'APPLY_LOCAL_SORT',
  'SORT_LOCAL',
  'APPLY_LOCAL_VALUEFILTER',
  'SET_LOADING',
  'SET_GROUPING',
  'SET_REQUEST_ID',
  'SET_CUSTOM_HEADERS',
  'SET_CUSTOM_PAYLOAD',
]

export function generateConstants(id: string): TConstantMap {
  const map = {
    REQUEST: '',
    RECEIVE: '',
    SET_FILTER: '',
    APPLY_FILTER: '',
    SAVE_UI: '',
    SET_FILTER_MODE: '',
    SET_INCLUDED: '',
    CLEAR_FILTERS: '',
    SET_SORT: '',
    APPLY_LOCAL_FILTER: '',
    SET_ITEMS: '',
    APPLY_LOCAL_FULLTEXTFILTER: '',
    APPLY_LOCAL_SORT: '',
    SORT_LOCAL: '',
    APPLY_LOCAL_VALUEFILTER: '',
    SET_LOADING: '',
    SET_GROUPING: '',
    SET_REQUEST_ID: '',
    SET_CUSTOM_HEADERS: '',
    SET_CUSTOM_PAYLOAD: '',
  }

  forEach(constants, (c) => set(map, c, id + c))
  return map
}
